(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

// Each card cycles through exactly the first two product photos every five seconds.
if (!customElements.get('jit-shop-gallery')) {
  customElements.define('jit-shop-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const frames = [...this.querySelectorAll('.jit-shop-card__frame')];
      const button = this.querySelector('.jit-shop-card__photo-toggle');
      if (frames.length < 2 || !button) return;
      let index = 0, timer = null, visible = false, paused = false, hovering = false, focused = false;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const events = new AbortController();
      const loadFrame = (image) => {
    if (!image || !image.dataset.jitSrc) return;
    image.loading = 'eager';
    image.decoding = 'async';
    if (image.dataset.jitSrcset) { image.srcset = image.dataset.jitSrcset; delete image.dataset.jitSrcset; }
    image.src = image.dataset.jitSrc;
    delete image.dataset.jitSrc;
  };
      const stop = () => { clearInterval(timer); timer = null; };
      const sync = () => {
        stop();
        button.hidden = motion.matches;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', (paused ? 'Play' : 'Pause') + ' photos for ' + this.dataset.productName);
        button.title = paused ? 'Play photos' : 'Pause photos';
        if (paused || motion.matches || !visible || document.hidden || hovering || focused) return;
        loadFrame(frames[(index + 1) % frames.length]);
        timer = setInterval(() => {
          const next = (index + 1) % frames.length;
          if (!frames[next].complete || !frames[next].naturalWidth) return;
          frames[index].classList.remove('is-active');
          frames[index].setAttribute('aria-hidden', 'true');
          frames[next].classList.add('is-active');
          frames[next].setAttribute('aria-hidden', 'false');
          index = next;
          this.dataset.activeImage = String(index + 1);
        }, 5000);
      };
      frames.forEach((frame, i) => { frame.classList.toggle('is-active', i === 0); frame.setAttribute('aria-hidden', String(i !== 0)); });
      this.dataset.activeImage = '1';
      button.addEventListener('click', () => { paused = !paused; sync(); }, {signal: events.signal});
      this.addEventListener('mouseenter', () => { hovering = true; sync(); }, {signal: events.signal});
      this.addEventListener('mouseleave', () => { hovering = false; sync(); }, {signal: events.signal});
      this.addEventListener('focusin', () => { focused = true; sync(); }, {signal: events.signal});
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { focused = false; sync(); } }, {signal: events.signal});
      document.addEventListener('visibilitychange', sync, {signal: events.signal});
      motion.addEventListener('change', sync, {signal: events.signal});
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold: .15});
      observer.observe(this);
      this.cleanup = () => { stop(); events.abort(); observer.disconnect(); this.cleanup = null; };
      sync();
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); }
  });
}


  } catch(e) { console.error(e); }
})();
})();
